Ext.define('SA.model.RadiusLocationSize', {
    singleton: true,

    metersPerUnit: {
        m: 1,
        km: 1000,
        feet: 0.3048,
        miles: 1609.344
    },

    getValueInMeters({value, unit}) {
        return value * this.metersPerUnit[unit];
    }
});